import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const normalizeRole = (value) => `${value || ""}`.toUpperCase();

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const location = useLocation();
  const { isAuthenticated, role } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (allowedRoles.length > 0) {
    const currentRole = normalizeRole(role);
    const canAccess = allowedRoles.map(normalizeRole).includes(currentRole);
    if (!canAccess) {
      return <Navigate to="/property-listings" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
